<script setup>
import { useRoute } from '@js/utils/route';
import { toastError, toastSuccess } from '@js/utils/toast';
import { ref } from 'vue';

const { callback } = defineProps({
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(route('front.projectManagement.apikom.postImportPhoneCalls'))
        .then((response) => {
            const { imported, updated } = response.data;

            const messages = [];

            if (imported > 0) {
                messages.push(
                    `${imported} appel${imported > 1 ? 's' : ''} importé${imported > 1 ? 's' : ''}`,
                );
            }

            if (updated > 0) {
                messages.push(
                    `${updated} appel${updated > 1 ? 's' : ''} mis à jour`,
                );
            }

            toastSuccess(
                messages.length > 0
                    ? `${messages.join(', ')}.`
                    : 'Aucun nouvel appel.',
            );

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            toastError(error);
        })
        .finally(() => {
            loading.value = false;
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
